module.exports = __webpack_public_path__ + "static/media/delete_image.fad8a032.svg";